export var LegalEntityTypeAnswerValue = /* @__PURE__ */ ((LegalEntityTypeAnswerValue2) => {
  LegalEntityTypeAnswerValue2["Ltd"] = "Ltd";
  LegalEntityTypeAnswerValue2["Sas"] = "Sas";
  LegalEntityTypeAnswerValue2["Llp"] = "Llp";
  LegalEntityTypeAnswerValue2["Kg"] = "Kg";
  LegalEntityTypeAnswerValue2["Ohg"] = "Ohg";
  return LegalEntityTypeAnswerValue2;
})(LegalEntityTypeAnswerValue || {});
